// The mock/real seam (task [2.5]). ONE hook signature regardless of fetcher.
// When VITE_API_URL is unset/empty the sync mock backs the query; otherwise the
// real fetcher does. TanStack Query accepts a queryFn returning a value OR a
// Promise, so no adapter is needed. No page component branches on mock-vs-real —
// this file is the only place that decision lives.

import { useQuery } from '@tanstack/react-query';

import { env } from '@/env';
import { getOverviewMock, type OverviewData } from './mock';
import { getOverview } from './real';

export const overviewQueryKey = ['overview'] as const;

export function useOverviewData() {
	return useQuery<OverviewData>({
		queryKey: overviewQueryKey,
		queryFn: () => (env.VITE_API_URL ? getOverview() : getOverviewMock()),
	});
}
